import React from "react";
import { Navigate, Route } from "react-router-dom";

const ProtectedRoute = ({ element, isAuthenticated }) => {
  return isAuthenticated ? (
    element
  ) : (
    <Navigate to="/olm-unauthorized" replace />
  );
};

export default ProtectedRoute;
